export default {
  title: 'Uusi kategoria',
  form: {
    menus: {
      label: 'Valikot',
    },
    printer: {
      label: 'Tulostin',
    },
    type: {
      label: 'Tyyppi',
    },
    name: {
      label: 'Nimi',
      placeholder: 'Syötä kategorian nimi',
    },
    description: {
      label: 'Kuvaus',
      placeholder: 'Syötä kuvaus',
    },
    has_combo_tax: {
      label: 'Sisältää yhdistelmäveron',
    },
    modifier_groups: {
      label: 'Lisäainemuttoset ryhmät',
    },
    image: {
      label: 'Kuva',
    },
    identifiers: {
      label: 'Tunnisteet',
    },
    has_separate_schedule: {
      label: 'Vaihtelee valikkoaikataulun mukaan',
    },
  },
  buttons: {
    save: 'Tallenna',
    close: 'Sulje',
  },
  feedback: {
    missing_info: 'Tiedot puuttuvat',
  },
  toasts: {
    category_got_created: 'Kategoria luotiin',
    category_got_updated: 'Kategoria päivitettiin',
  },
};
